const MoreIcon = ({ className }) => {
  return (
    <div className={className}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <circle cx="6" cy="12" r="2" fill="url(#paint0_linear_1268_64725)" />
        <circle cx="6" cy="12" r="2" className="fill-primary-600" />
        <circle cx="6" cy="12" r="2" className="fill-primary-600" />
        <circle cx="12" cy="12" r="2" fill="url(#paint1_linear_1268_64725)" />
        <circle cx="12" cy="12" r="2" className="fill-primary-600" />
        <circle cx="12" cy="12" r="2" className="fill-primary-600" />
        <circle cx="18" cy="12" r="2" fill="url(#paint2_linear_1268_64725)" />
        <circle cx="18" cy="12" r="2" className="fill-primary-600" />
        <circle cx="18" cy="12" r="2" className="fill-primary-600" />
        <defs>
          <linearGradient
            id="paint0_linear_1268_64725"
            x1="6"
            y1="10"
            x2="6"
            y2="14"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#E3BD5E" />
            <stop offset="1" stopColor="#F3DB89" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_1268_64725"
            x1="12"
            y1="10"
            x2="12"
            y2="14"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#E3BD5E" />
            <stop offset="1" stopColor="#F3DB89" />
          </linearGradient>
          <linearGradient
            id="paint2_linear_1268_64725"
            x1="18"
            y1="10"
            x2="18"
            y2="14"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#E3BD5E" />
            <stop offset="1" stopColor="#F3DB89" />
          </linearGradient>
        </defs>
      </svg>
    </div>
  );
};

export default MoreIcon;